import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PackageDateEditTabs from 'components/PackageDateEditTabs';
import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import PackageDateSidebar from 'components/PackageDateSidebar';

import { withData } from 'lib';
import { PackageDateEditPageQuery } from '__generated__/PackageDateEditPageQuery.graphql';

const query = graphql`
  query PackageDateEditPageQuery($id: ID!) {
    packageDate(id: $id) {
      start
      end

      package {
        id
        name
      }

      ...PackageDateEditTabs_packageDate
      ...PackageDateSidebar_packageDate
    }

    ...PackageDateEditTabs_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<PackageDateEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/packages', name: 'Pasiūlymai' }];

const PackageDateEditPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<PackageDateEditPageQuery>(
    query,
    preloadedQuery
  );

  const { packageDate } = data;

  if (!packageDate) {
    return <NotFound />;
  }

  const { start, end } = packageDate;

  return (
    <PageWithSidebar
      sidebar={<PackageDateSidebar packageDate={packageDate} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          link: `/packages/${packageDate.package.id}`,
          name: packageDate.package.name,
        },
        {
          name: `${start} - ${end}`,
        },
      ]}>
      <PackageDateEditTabs packageDate={packageDate} data={data} />
    </PageWithSidebar>
  );
};

export default withData<PackageDateEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(PackageDateEditPage);
